module.exports = __webpack_public_path__ + "img/expand-stat.9741a0b7.svg";